/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { memo, useMemo } from 'react'
import {
  CustomerCollectedDataStatus,
  CustomerPaymentMethodStatus,
  CustomerResubmitInfoType,
} from 'src/constants/customer/enums'
import { MCStatus } from 'src/constants/mc/enums'
import { MCDetails } from 'src/interfaces/mc'
import tw from 'twin.macro'
import { MCPendingStep } from '../shared/MCPendingStep'
import { MCStepItem, MCStepParams } from '../shared/MCStepItem'
import { MCStepDetails } from '../types'

interface Props {
  mcDetails: MCDetails
  onSelectStep: (stepDetails: MCStepDetails) => void
}

const OnboardingStepsTabComponent = memo(({ mcDetails }: Props) => {
  const steps: MCStepParams[] = useMemo(() => {
    const res: MCStepParams[] = []

    let paymentMethodStatus = CustomerCollectedDataStatus.Created

    if (mcDetails.partner.paymentMethod?.status === CustomerPaymentMethodStatus.Active) {
      paymentMethodStatus = CustomerCollectedDataStatus.Completed
    }

    res.push({
      stepStatus: paymentMethodStatus,
      stepType: CustomerResubmitInfoType.PaymentInfo,
    })

    return res
  }, [mcDetails])

  return (
    <div css={tw`flex flex-1 flex-col overflow-y-auto h-full bg-[rgba(246, 246, 246, 1)]`}>
      <div css={tw`p-4 pb-20`}>
        {mcDetails.status === MCStatus.Invited && (
          <div css={tw`flex flex-col gap-2`}>
            <MCPendingStep mcDetails={mcDetails} />
            {steps.map(
              ({
                stepStatus,
                stepType,
                expiresAt,
                onResubmitInfo,
                onChangeExpirationDate,
                onViewDetails,
              }) => (
                <MCStepItem
                  stepStatus={stepStatus}
                  key={stepType}
                  stepType={stepType}
                  expiresAt={expiresAt}
                  onResubmitInfo={onResubmitInfo}
                  onViewDetails={onViewDetails}
                  onChangeExpirationDate={onChangeExpirationDate}
                />
              ),
            )}
          </div>
        )}

        {(mcDetails.status === MCStatus.Activated || mcDetails.status === MCStatus.Deactivated) && (
          <div css={tw`flex flex-col gap-2`}>
            {steps.map(
              ({
                stepStatus,
                stepType,
                expiresAt,
                onResubmitInfo,
                onChangeExpirationDate,
                onViewDetails,
              }) => (
                <MCStepItem
                  stepStatus={stepStatus}
                  key={stepType}
                  stepType={stepType}
                  expiresAt={expiresAt}
                  onResubmitInfo={onResubmitInfo}
                  onViewDetails={onViewDetails}
                  onChangeExpirationDate={onChangeExpirationDate}
                />
              ),
            )}
          </div>
        )}
      </div>
    </div>
  )
})

export const OnboardingStepsTab = OnboardingStepsTabComponent
